import { render, staticRenderFns } from "./Sensor.vue?vue&type=template&id=699d182a&"
import script from "./Sensor.vue?vue&type=script&lang=ts&"
export * from "./Sensor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPage,QCard,QCardSection,QInput,QBtn,QIcon,QDialog} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPage,QCard,QCardSection,QInput,QBtn,QIcon,QDialog})
